import React, { useState, useEffect } from 'react';
import images from '../images';
import { CartaProducto } from './CartaProducto';
import { Titulo } from './Titulo';
import styles from '../css/Outlet.module.scss'
import { useContextoGlobal } from '../ContextoGlobal';
import { formatearJsonProductos } from '../functions.js';
import axiosRequest from '../axiosRequest.js';
export const Outlet = () => {
    const [outlet, setOutlet] = useState([]);
    const [leftAct, setLeftAct] = useState(0);
    const { agregarItemsCarrito } = useContextoGlobal();

    useEffect(() => {
        axiosRequest.get("/products?featured=true&&on_sale=true")
            .onResponse((response) => {
                setOutlet(formatearJsonProductos(response.data));
            })
    }, [])

    function siguienteProducto() {
        const container = document.getElementById('contOfertas');
        var left = 0;
        if (container.scrollLeft === 0 && document.getElementById('prod1'))
            left = 445
        else if (container.scrollLeft + container.clientWidth < container.scrollWidth - 12) {
            left = container.scrollLeft + 397
        }
        container.scrollTo({
            left: left,
            behavior: 'smooth'
        })
    }

    function anteriorProducto() {
        const container = document.getElementById('contOfertas');
        var left = 0;
        if (container.scrollLeft <= 48)
            left = container.scrollWidth - 445
        else if (leftAct === container.scrollWidth - 445) {
            left = leftAct - 397 * Math.round(window.screen.availWidth / 397)
        }
        else {
            left = leftAct - 397
        }
        setLeftAct(left)
        container.scrollTo({
            left: left,
            behavior: 'smooth'
        })
    }

    return (
        <>
            <div className={'container-fluid py-5 px-0 ' + styles.outlet}>
                {outlet.length > 0 ?
                    <>
                        <div className='row mx-5 px-3'>
                            <div className='col p-0'>
                                <Titulo texto={"NUESTRO OUTLET"} subrayar={true} classSubrayado={styles.subrayado} />
                            </div>
                            <div className='col-2 w-auto p-0'>
                                <button type="button" class={"btn btn-outline-dark fw-bold centrarContainer mt-5 " + styles.btnVerMas}
                                    onClick={() => window.location.href = "/outlet"}>Ver Más
                                    <img className={'ms-2 ' + styles.flechaBtn} src={images.icons.flechaBoton} />
                                </button>
                            </div>

                        </div>
                        <div className='position-relative'>
                            <img src={images.icons.flecha} className={styles.flechaIzq} onClick={anteriorProducto} />
                            <img src={images.icons.flecha} className={styles.flechaDer} onClick={siguienteProducto} />
                            <div id='contOfertas' className={'py-5 px-5 ' + styles.contOfertas}>
                                {outlet.map(function (elem, i) {
                                    return (
                                        <CartaProducto idCarta={'prod' + i} producto={elem} />
                                    )
                                })}
                            </div>
                        </div></>

                    :
                    <></>
                }</div>
        </>
    )

}
